import Client from './axiosClient'
const resourceInit = '/dashboard/bootstrap'
const resourceFilter = '/dashboard/filter'

export default {
  init() {
    return Client.get(`${resourceInit}`);
  },

  filter(payload) {
    return Client.post(`${resourceFilter}`, payload);
  }


  // MANY OTHER ENDPOINT RELATED STUFFS
};



// WEBPACK FOOTER //
// ./src/repositories/dashboardRepository.js